var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212121;}\r\n\t.st1{fill:#717171;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 32,
    r: 31.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,15.7c5.3,0,5.9,0,8,0.1c1.9,0.1,3,0.4,3.7,0.7c0.9,0.4,1.6,0.8,2.3,1.5c0.7,0.7,1.1,1.4,1.5,2.3 c0.3,0.7,0.6,1.7,0.7,3.7c0.1,2.1,0.1,2.7,0.1,8s0,5.9-0.1,8c-0.1,1.9-0.4,3-0.7,3.7c-0.4,0.9-0.8,1.6-1.5,2.3 c-0.7,0.7-1.4,1.1-2.3,1.5c-0.7,0.3-1.7,0.6-3.7,0.7c-2.1,0.1-2.7,0.1-8,0.1c-5.3,0-5.9,0-8-0.1c-1.9-0.1-3-0.4-3.7-0.7 c-0.9-0.4-1.6-0.8-2.3-1.5c-0.7-0.7-1.1-1.4-1.5-2.3c-0.3-0.7-0.6-1.7-0.7-3.7c-0.1-2.1-0.1-2.7-0.1-8s0-5.9,0.1-8 c0.1-1.9,0.4-3,0.7-3.7c0.4-0.9,0.8-1.6,1.5-2.3c0.7-0.7,1.4-1.1,2.3-1.5c0.7-0.3,1.7-0.6,3.7-0.7C26.1,15.8,26.7,15.7,32,15.7  M32,12.2c-5.4,0-6.1,0-8.2,0.1c-2.1,0.1-3.6,0.4-4.8,0.9c-1.3,0.5-2.4,1.2-3.5,2.3c-1.1,1.1-1.8,2.2-2.3,3.5 c-0.5,1.3-0.8,2.7-0.9,4.8c-0.1,2.1-0.1,2.8-0.1,8.2c0,5.4,0,6.1,0.1,8.2c0.1,2.1,0.4,3.6,0.9,4.8c0.5,1.3,1.2,2.4,2.3,3.5 c1.1,1.1,2.2,1.8,3.5,2.3c1.3,0.5,2.7,0.8,4.8,0.9c2.1,0.1,2.8,0.1,8.2,0.1c5.4,0,6.1,0,8.2-0.1c2.1-0.1,3.6-0.4,4.8-0.9 c1.3-0.5,2.4-1.2,3.5-2.3c1.1-1.1,1.8-2.2,2.3-3.5c0.5-1.3,0.8-2.7,0.9-4.8c0.1-2.1,0.1-2.8,0.1-8.2s0-6.1-0.1-8.2 c-0.1-2.1-0.4-3.6-0.9-4.8c-0.5-1.3-1.2-2.4-2.3-3.5c-1.1-1.1-2.2-1.8-3.5-2.3c-1.3-0.5-2.7-0.8-4.8-0.9 C38.1,12.2,37.4,12.2,32,12.2L32,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,21.8c-5.6,0-10.2,4.6-10.2,10.2S26.4,42.2,32,42.2c5.6,0,10.2-4.6,10.2-10.2S37.6,21.8,32,21.8z  M32,38.6c-3.7,0-6.6-3-6.6-6.6s3-6.6,6.6-6.6s6.6,3,6.6,6.6S35.7,38.6,32,38.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42.6,
    cy: 21.4,
    r: 2.4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3a1c08dfd43dfa06d663fb7d83f9a2f8.svg";
export { ForwardRef as ReactComponent };